import React, {Component} from "react"
import {injectIntl} from "react-intl"
import {Select} from 'formsy-react-components'

import {
  ENTERPRISE_ACCOUNT_SUBTYPE_COGO_PVT, ENTERPRISE_ACCOUNT_SUBTYPE_DESC, ENTERPRISE_ACCOUNT_SUBTYPE_NONE
} from "../../constants"

class EnterpriseAccountSubTypeSelect extends Component {

  render() {

    const data = [
      {
        code: ENTERPRISE_ACCOUNT_SUBTYPE_COGO_PVT,
        desc: ENTERPRISE_ACCOUNT_SUBTYPE_DESC[ENTERPRISE_ACCOUNT_SUBTYPE_COGO_PVT]
      },
      ]

    const options = data.map(
      (c) =>
        ({
          value: c.code,
          label: c.desc
        })
    )

    return (
      <Select name={this.props.name}
              label={'Sub Type'}
              value={this.props.value || ENTERPRISE_ACCOUNT_SUBTYPE_NONE}
              options={[{value: ENTERPRISE_ACCOUNT_SUBTYPE_NONE, label: 'Please select sub type ...'}, ...options]}
              required={this.props.required}
              {...this.props}
      >
      </Select>
    )
  }
}

export default injectIntl(EnterpriseAccountSubTypeSelect)



// WEBPACK FOOTER //
// ./src/components/form/EnterpriseAccountSubTypeSelect.js